import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
export function StickyTopBar() {
  const [secondsLeft, setSecondsLeft] = useState(() => {
    const saved = sessionStorage.getItem('countdown_end');
    if (saved) {
      const remaining = Math.floor((parseInt(saved) - Date.now()) / 1000);
      return remaining > 0 ? remaining : 0;
    }
    const end = Date.now() + 10 * 60 * 1000;
    sessionStorage.setItem('countdown_end', String(end));
    return 10 * 60;
  });
  useEffect(() => {
    if (secondsLeft <= 0) return;
    const interval = setInterval(() => {
      setSecondsLeft(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [secondsLeft > 0]);
  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;
  const timeDisplay = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  return <div className="sticky top-0 z-50 w-full text-white py-2.5 px-4 shadow-md bg-[#000000]" data-id="element-221">
      <div className="max-w-6xl mx-auto flex items-center justify-center text-center text-xs sm:text-sm md:text-base font-medium gap-2" data-id="element-222">
        <ClockIcon className="w-4 h-4 sm:w-5 sm:h-5 text-white flex-shrink-0 animate-pulse bg-[#030303]" data-id="element-223" />
        <span className="text-[14px] font-[900] text-[#DE2323]" data-id="element-224">
          La oferta finalizará en
        </span>
        <span className="text-[16px] font-[900] tabular-nums tracking-wider text-[#FFE609]" data-id="element-225">
          {timeDisplay}
        </span>
      </div>
    </div>;
}